import { Fragment } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { apolloClient } from 'lib/withApollo'
import getSitesForStaticPaths from 'helpers/getSitesForStaticPaths'
import HIGHLIGHT_QUERY from 'graphql/highlight.query'
import HIGHLIGHTS_QUERY from 'graphql/highlights.query'

import Layout from 'components/Layout'
import WordpressSEO from 'components/WordpressSEO'
import SliderCover from 'components/SliderCover'
import Blocks from 'components/Blocks'
import ArticlesRelated from 'components/ArticlesRelated'

import s from './highlight.module.css'

function Highlight({ site, highlight, slug, globalSettings }) {
  const { title, acfHighlightCover, acfHighlightSettings, acfBlocks } =
    highlight

  const {
    models,
    globalBrandTag,
    globalCampaignTag,
    globalCategoriesTag,
    globalPhotographerTag,
    globalPublicationTag,
    globalStylistTag,
  } = acfHighlightSettings

  const setSidebarItems = [
    globalBrandTag[0],
    globalCampaignTag[0],
    globalCategoriesTag[0],
    globalPhotographerTag[0],
    globalPublicationTag[0],
    globalStylistTag[0],
  ]

  const relatedPosts = models?.relatedPosts

  const setCovers = [
    {
      acfBlocks,
      acfHighlightCover: {
        shortDescription: acfHighlightCover?.shortDescription,
        covers: acfHighlightCover?.covers,
      },
      acfHighlightSettings,
      slug,
    },
  ]

  const setSidebarItem = (label, name) => {
    return (
      <>
        <h3 className={s.label} dangerouslySetInnerHTML={{ __html: label }} />
        <h4 className={s.name} dangerouslySetInnerHTML={{ __html: name }} />
      </>
    )
  }

  return (
    <Layout globalSettings={globalSettings}>
      <WordpressSEO
        url={`/${site}/highlight/${slug}`}
        title={highlight.title}
        seo={highlight.seo}
      />
      <SliderCover covers={setCovers} noLink />
      <div className={s.container}>
        <div className={s.blocks}>
          {acfBlocks && <Blocks postType="Highlight">{acfBlocks}</Blocks>}
        </div>
        <div className={s.sidebar}>
          <h3
            className={classNames(s.label, s.labelMobile)}
            dangerouslySetInnerHTML={{ __html: 'Credits' }}
          />
          {models && setSidebarItem(models.__typename, models.title)}
          {title && setSidebarItem('Title', title)}
          {setSidebarItems.map((item) => {
            if (!item) return null
            return (
              <Fragment key={item.name}>
                {setSidebarItem(item.__typename, item.name)}
              </Fragment>
            )
          })}
        </div>
      </div>
      <ArticlesRelated articles={relatedPosts} />
    </Layout>
  )
}

Highlight.propTypes = {
  site: PropTypes.string,
  slug: PropTypes.string,
  highlight: PropTypes.object,
  globalSettings: PropTypes.object,
}
Highlight.defaultProps = {
  site: '',
  slug: '',
  highlight: null,
  globalSettings: {},
}

export default Highlight

export async function getStaticProps({ params }) {
  const { site, slug } = params
  const { data, error } = await apolloClient().query({
    query: HIGHLIGHT_QUERY,
    context: { site },
    variables: { slug },
  })

  if (error) console.log(`Error loading Highlight props - ${error}`)

  return {
    props: {
      ...params,
      highlight: data.highlightBy,
    },
    revalidate: 60 * 2,
  }
}

export async function getStaticPaths() {
  const paths = []

  await getSitesForStaticPaths(
    ({ site }) => ({
      query: HIGHLIGHTS_QUERY,
      context: { site },
    }),
    (data, { site }) =>
      data.highlights.nodes.map((n) => {
        paths.push({
          params: {
            site,
            slug: n.slug,
          },
        })
      })
  )

  return {
    paths,
    fallback: false,
  }
}
